import { Mail, MapPin, Phone } from "lucide-react";
import { Link } from "react-router-dom";

const LINKS = [
  { label: "Thesis", href: "#thesis" },
  { label: "Parcels", href: "#parcels" },
  { label: "Infrastructure", href: "#infrastructure" },
];

export default function Footer({ onNavigate }) {
  return (
    <footer id="contact" className="border-t border-border" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 py-16 md:px-10 md:py-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="relative flex h-8 w-8 items-center justify-center border-2 border-foreground">
                <span className="absolute inset-1 bg-accent" />
              </span>
              <span className="font-display text-lg font-extrabold uppercase tracking-tight">
                Dholera<span className="text-accent"> NextEra</span>
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-muted-foreground">
              A specialist marketplace for surveyed parcels inside Dholera SIR —
              plotted against expressways, runways and fabs, not brochures.
            </p>
            <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
              22.2487° N — 72.1952° E
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
              Index
            </p>
            <div className="mt-4 flex flex-col items-start gap-3">
              {LINKS.map((l) => (
                <button
                  key={l.href}
                  onClick={() => onNavigate(l.href)}
                  className="text-sm text-muted-foreground transition-colors duration-200 hover:text-accent"
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                >
                  {l.label}
                </button>
              ))}
              <Link
                to="/investments"
                className="text-sm text-muted-foreground transition-colors duration-200 hover:text-accent"
                data-testid="footer-link-investments"
              >
                Investment Hub
              </Link>
            </div>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
              Desk
            </p>
            <div className="mt-4 space-y-3 font-mono text-xs text-muted-foreground">
              <p className="flex items-center gap-2.5">
                <Mail className="h-3.5 w-3.5 text-accent" />
                support@dholeranextera.com
              </p>
              <p className="flex items-center gap-2.5">
                <Phone className="h-3.5 w-3.5 text-accent" />
                +91 98 0293 4440
              </p>
              <p className="flex items-center gap-2.5">
                <Phone className="h-3.5 w-3.5 text-accent" />
                +91 98 1300 0000
              </p>
              <p className="flex items-start gap-2.5">
                <MapPin className="mt-0.5 h-3.5 w-3.5 shrink-0 text-accent" />
                Gap Group Building, Dholera SIR,
                <br />
                Gujarat 382455
              </p>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col justify-between gap-3 border-t border-border pt-6 md:flex-row">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
            © 2026 Dholera NextEra — Demonstration Marketplace
          </p>
          <div className="flex items-center gap-6">
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground/70">
              All parcels, prices & RERA IDs are illustrative mock data
            </p>
            <Link
              to="/desk"
              className="shrink-0 font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground transition-colors duration-200 hover:text-accent"
              data-testid="footer-link-desk"
            >
              Team Desk
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
